import { EventRecordStatus } from "@/generated/model/eventRecordStatus";

/**
 * The print sheet's own status vocabulary (NAU-342).
 *
 * Separate from `eventRecordPill` because the PDF cannot use the app's Badge
 * component or its palette — it has its own print CSS classes — but it must not
 * disagree with the screen either. Keeping the mapping here, as a pure module,
 * means it is unit-tested rather than buried in a `.tsx` the test runner does not
 * collect.
 *
 * Before this, the sheet printed a two-state acknowledged/not badge derived from
 * whether an acknowledgement row existed, so a resolved or archived record printed
 * as merely "Acknowledged" — and one resolved without ever being acknowledged
 * printed "Awaiting acknowledgement" on evidence an inspector might read.
 */
export type PrintStatusTone = "pending" | "progress" | "ack" | "archived";

export interface PrintStatus {
  tone: PrintStatusTone;
  label: string;
}

export function eventRecordPrintStatus(status: EventRecordStatus): PrintStatus {
  switch (status) {
    case EventRecordStatus.IN_PROGRESS:
      return { tone: "progress", label: "In progress" };
    case EventRecordStatus.RESOLVED:
      return { tone: "ack", label: "Resolved" };
    case EventRecordStatus.ARCHIVED:
      return { tone: "archived", label: "Archived" };
    default:
      // Any unrecognised state reads as needing attention rather than as fine —
      // the same defensive default `eventRecordPill` takes.
      return { tone: "pending", label: "Awaiting acknowledgement" };
  }
}
